import React from "react";
import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ricochet-savings/artifacts/fnyt4egh_Ricochet%20logo%202018%20crop.png";

export const Footer = () => {
  return (
    <footer
      className="bg-[#2a1f4a] text-white mt-8"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div>
            <div className="bg-white inline-block rounded-xl p-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Ricochet Fuel Distributors"
                className="h-14 w-auto"
                data-testid="footer-logo"
              />
            </div>
            <p className="text-sm text-white/70 leading-relaxed max-w-sm">
              Premium bulk fuel distribution and on-site fleet fueling — keeping
              America&apos;s commercial fleets moving since 1988.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display font-bold text-lg text-[#ecac1f] tracking-wide mb-4">
              CONTACT
            </h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#ecac1f] shrink-0" />
                <div>
                  <a
                    href="tel:+18339255065"
                    className="text-white hover:text-[#ecac1f] transition-colors"
                    data-testid="footer-phone-main"
                  >
                    833-925-5065
                  </a>
                  <div className="text-xs text-white/55">
                    Call us 24/7
                  </div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#ecac1f] shrink-0" />
                <a
                  href="mailto:sales@ricochetfuel.com"
                  className="text-white hover:text-[#ecac1f] transition-colors"
                  data-testid="footer-email"
                >
                  sales@ricochetfuel.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#ecac1f] shrink-0" />
                <div className="text-white/80">
                  1201 Royal Parkway
                  <br />
                  Euless, TX 76040
                </div>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-display font-bold text-lg text-[#ecac1f] tracking-wide mb-4">
              QUICK LINKS
            </h3>
            <ul className="space-y-2.5 text-sm">
              {[
                { label: "Main Website", href: "https://www.ricochetfuel.com" },
                {
                  label: "Services",
                  href: "https://www.ricochetfuel.com/services/",
                },
                {
                  label: "Customer Portal",
                  href: "https://www.ricochetfuel.com/ricochet-fuel-customer-portal/",
                },
                {
                  label: "Contact Us",
                  href: "https://www.ricochetfuel.com/contact-us/",
                },
              ].map(({ label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-white/80 hover:text-[#ecac1f] transition-colors"
                    data-testid={`footer-link-${label
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {label}
                    <ExternalLink className="w-3 h-3" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/55">
          <div>
            © {new Date().getFullYear()} Ricochet Fuel Distributors, Inc. All
            rights reserved.
          </div>
          <div className="italic text-[#ecac1f]/80 font-semibold">
            We Keep You Moving!
          </div>
        </div>
      </div>
    </footer>
  );
};
